import { Box } from '@mui/material';
import image from '@/assets/images/storeManagement/layouts.png';
import { useTranslation } from 'react-i18next';

export default function GetStartPage() {
    const { t } = useTranslation('common');
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: { xs: '300px', sm: '360px', md: '400px', lg: '520px' },
                    }}
                >
                    <img
                        src={image}
                        alt={t("Let's get started illustration")}
                        loading="lazy"
                        style={{ width: '100%' }}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                <Box className="started-title">
                    <span>{t("Let's Get Started !")}</span>
                </Box>
            </Box>
            <Box className="started-description" sx={{ mt: 5 }}>
                <Box sx={{ mb: 1 }}> {t('Looks like you haven’t picked a layout package yet.')}</Box>
            </Box>
        </>
    );
}
